/** Desktop rail width. Shared by Helpdesk and platform shells so a remount keeps the choice. */
export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'gb.sidebar.collapsed.v1';

export function readSidebarCollapsed(storage: Storage | null | undefined): boolean {
  if (!storage) {
    return false;
  }
  try {
    return storage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeSidebarCollapsed(
  storage: Storage | null | undefined,
  collapsed: boolean,
): void {
  if (!storage) {
    return;
  }
  try {
    storage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, collapsed ? '1' : '0');
  } catch {
    /* quota / private mode */
  }
}
